/* eslint-disable jsx-a11y/aria-role */
import Grid from '@material-ui/core/Grid';
import { CardContent, Divider, TextField, Toolbar } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import Alert from '@material-ui/lab/Alert';
import AlertTitle from '@material-ui/lab/AlertTitle';
import * as _ from 'lodash';
import { useStateObject } from 'hooks/utils';
import { Autocomplete } from '@material-ui/lab';
import CollectionItemHeader from '../../layout/CollectionItemHeader';
import AppButtonMinimal from '../../basic/AppButtonMinimal';
import { useItem } from '../../../hooks/atoms/item-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import AppLoader from '../../basic/AppLoader';
import BasicField from '../../basic/BasicField';
import getTheme from '../../../theme/theme';
import { realRoleNames } from '../../../cassandra-shared-js/roles';
import { useDialog } from '../../../dialog-provider-hooks';

const UserDetails = ({
  id,
}) => {
  const {
    item: user,
    itemIsLoading,
    itemError,
    updateItem: updateUser,
  } = useItem(CollectionKeys.ADMIN_TOOL_USERS, id);

  const [ editUser, setEditUser ] = useStateObject(user);
  const [ editRole, setEditRole ] = useState('');

  useEffect(() => {
    if (undefined !== user) {
      const foundRole = Object.values(realRoleNames).find((s) => {
        return s.value === user.role.name;
      });
      if (foundRole) {
        setEditRole(foundRole);
      }
    }
  }, [ user ]);

  const { openDialog } = useDialog();

  const openVerifyUserDialog = (verify) => {
    openDialog({
      title: verify ? 'Verify User ?' : 'Disclaim User ?',
      body() {
        return (
          <>
            {verify ? <p>{`Are you sure you want to verify ${ user.name } ${ user.family_name }`}</p>
              : <p>{`Are you sure you want to disclaim ${ user.name } ${ user.family_name }`}</p>}
          </>
        );
      },
      onSubmit() {
        return updateUser({ verification_status: verify ? 'VERIFIED' : 'UNVERIFIED' });
      },
    });
  };

  const openUpdateUserDialog = () => {
    openDialog({
      title: 'Update User Details ?',
      body() {
        return (<p>{`Are you sure you want to update user ${ user.name } ${ user.family_name }`}</p>);
      },
      onSubmit() {
        return updateUser({ name: editUser.name, family_name: editUser.family_name, role: editRole?.value, blocked: false });
      },
    });
  };

  if (itemIsLoading) {
    return <AppLoader />;
  }

  if (itemError) {
    return <p>Error</p>;
  }

  const rolesOptions = Object.values(realRoleNames).filter((val) => {
    return true !== val.hidden;
  });

  const userName = user.name || '';
  const userFamilyName = user.family_name || '';

  return (
    <>
      <CollectionItemHeader
        title={ `${ userName } ${ userFamilyName }` }
        subtitle={ `Created at: ${ user.created_at }` }
        actions={ (
          <>
            <div />
            <Grid container spacing={ 1 } justify='flex-end'>
              <Grid item>
                <AppButtonMinimal
                  text='Reset password'
                  color={ getTheme().palette.warning.main }
                  onClick={ () => { } }
                />
              </Grid>
              <Grid item>
                <AppButtonMinimal
                  text='Block'
                  color={ getTheme().palette.error.main }
                  onClick={ () => { } }
                />
              </Grid>
            </Grid>
          </>
        ) }
      />
      <Toolbar />
      <Grid container spacing={ 3 }>
        <Grid container item xs={ 12 } spacing={ 3 }>
          <Grid item xs={ 4 }>
            <Card>
              <CardContent>
                <Grid item xs={ 12 }>
                  <BasicField
                    title='Name'
                    field={ editUser?.name }
                    onChange={ (val) => {
                      setEditUser('name', val);
                    } }
                  />
                  <BasicField
                    title='Surname'
                    field={ editUser?.family_name }
                    onChange={ (val) => {
                      setEditUser('family_name', val);
                    } }
                  />
                  <BasicField
                    disabled
                    title='Email'
                    field={ user.email }
                  />
                  <BasicField
                    disabled
                    title='Username'
                    field={ editUser?.username }
                  />
                  <Grid item>
                    <Divider style={ { margin: getTheme().spacing(1, 0) } } />
                  </Grid>
                  <Autocomplete
                    id='user-roles'
                    options={ rolesOptions }
                    getOptionLabel={ (option) => { return option?.name ?? ''; } }
                    onChange={ (event, newValue) => {
                      setEditRole(newValue);
                    } }
                    value={ editRole }
                    renderInput={ (params) => {
                      const val = editRole?.name ?? '';

                      return (
                        <TextField
                          { ...params }
                          value={ val }
                          label='Select a role'
                          variant='outlined'
                          placeholder='Roles'
                        />
                      );
                    } }
                  />
                  <Grid item>
                    <Divider style={ { margin: getTheme().spacing(1, 0) } } />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={ 8 }>
            {'VERIFIED' === user.verification_status && (
              <Grid container spacing={ 2 }>
                <Grid item xs={ 12 }>
                  <Alert severity='success'>
                    <AlertTitle>Verified</AlertTitle>
                  </Alert>
                </Grid>
                <Grid item>
                  <AppButtonMinimal
                    text='Disclaim User'
                    color={ getTheme().palette.error.main }
                    onClick={ () => { openVerifyUserDialog(false); } }
                  />
                </Grid>
              </Grid>
            )}
            {'UNVERIFIED' === user.verification_status && (
              <Grid container spacing={ 2 }>
                <Grid item xs={ 12 }>
                  <Alert severity='warning'>
                    <AlertTitle>Not verified</AlertTitle>
                    You need to verify the user in order to give him/her access to the EMR
                  </Alert>
                </Grid>
                <Grid item>
                  <AppButtonMinimal
                    text='Verify User'
                    color={ getTheme().palette.info.main }
                    onClick={ () => { openVerifyUserDialog(true); } }
                  />
                </Grid>
              </Grid>
            )}
            <Grid item>
              <AppButtonMinimal
                text='Update User'
                color={ getTheme().palette.info.main }
                onClick={ () => { openUpdateUserDialog(true); } }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default UserDetails;
